export default "__VITE_ASSET__CIByo5Tf__"